import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/auth';
import { useCurrencyStore } from '../store/currency';
import CurrencyToggle from './CurrencyToggle';

const NAV = [
  { group: 'Overview' },
  { icon: '◈', label: 'Dashboard',         path: '/' },
  { icon: '◎', label: 'Net Worth',          path: '/networth' },

  { group: 'Money In / Out' },
  { icon: '↑', label: 'Upload CSV',         path: '/upload' },
  { icon: '$', label: 'Cash Transactions',  path: '/cash' },
  { icon: '≡', label: 'Transactions',       path: '/transactions' },
  { icon: '⇄', label: 'IOUs & Split',       path: '/iou' },

  { group: 'Planning' },
  { icon: '◉', label: 'Forecast',           path: '/forecast' },
  { icon: '⊕', label: 'Scenarios',          path: '/scenarios' },
  { icon: '▭', label: 'Loans',              path: '/loans' },

  { group: 'Assets' },
  { icon: '↗', label: 'Investments',        path: '/investments' },

  { group: 'Control' },
  { icon: '=', label: 'Reconciliation',     path: '/reconciliation' },
  { icon: '≣', label: 'Annual Report',      path: '/reports' },

  { group: 'Settings' },
  { icon: '◧', label: 'Categories',         path: '/categories' },
  { icon: '⊙', label: 'Income',             path: '/income' },
  { icon: '⌂', label: 'Household',          path: '/household' },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout } = useAuthStore();
  const loadRates = useCurrencyStore(s => s.loadRates);
  const [open, setOpen] = useState(false);

  // Load exchange rates once at app start
  useEffect(() => { loadRates(); }, [loadRates]);

  const goTo = (path) => { navigate(path); setOpen(false); };

  const navContent = (
    <>
      <div className="logo">
        Arca
        <span>{user?.full_name || user?.email}</span>
      </div>

      {NAV.map((item, i) => {
        if (item.group) return <div key={i} className="nav-group-label">{item.group}</div>;
        return (
          <button
            key={item.path}
            className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => goTo(item.path)}
          >
            <span className="icon">{item.icon}</span>
            {item.label}
          </button>
        );
      })}

      <div style={{ flex: 1 }} />

      {/* ── Global currency toggle ── */}
      <div style={{ borderTop: '1px solid rgba(255,255,255,0.08)', paddingTop: 10, marginTop: 8 }}>
        <div style={{ padding: '0 10px 5px', fontSize: 9.5, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.1em', color: 'rgba(255,255,255,0.3)' }}>
          View In
        </div>
        <CurrencyToggle />
      </div>

      <button className="nav-item" style={{ marginTop: 4 }} onClick={() => { logout(); navigate('/login'); }}>
        <span className="icon">⎋</span>
        Sign Out
      </button>
    </>
  );

  return (
    <>
      <div className="sidebar sidebar-desktop">{navContent}</div>

      <div className="mobile-topbar">
        <div className="logo" style={{ padding: 0, border: 'none', margin: 0 }}>Arca</div>
        <button className="hamburger" onClick={() => setOpen(!open)}>{open ? '×' : '☰'}</button>
      </div>

      {open && (
        <div className="mobile-overlay" onClick={() => setOpen(false)}>
          <div className="mobile-drawer" onClick={e => e.stopPropagation()}>{navContent}</div>
        </div>
      )}
    </>
  );
}
